<template>
  <section :class="[$options.name, { mobile: isMobile }]">
    <h1 v-if="title" class="tw:heading-1 tw:mb-2">
      {{ title }}
    </h1>
    <p v-if="subtitle" class="tw:body-1 tw:font-light tw:mb-6">
      {{ subtitle }}
    </p>
    <slot></slot>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "AccountContent",
  components: {},
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
});
</script>

<style lang="scss">
@use "vue-app/assets/scss/views/account/account.scss";
</style>
